module.exports = __webpack_public_path__ + "static/media/error_bg.d710f00e.png";